import CalculatorsController from '../../src/javascripts/cvm';
import EnfosRoi from '../../src/javascripts/models/enfos/roi';
import '../../src/javascripts/helpers/application/fa_checkbox_helper';
import '../../src/javascripts/helpers/application/self_service_pdf_launcher';
import '../../src/stylesheets/enfos/roi.scss';

(function() {
  $(() => CalculatorsController.run(new EnfosRoi()));
}).call(this);

$(() => {
  $('#pct-discount').on('blur', function() {
    console.log('checking')
    if (parseInt($('#pct-discount').val()) < 16) { return; }
    
    $('#pct-discount').val(15);
  });
});